<script lang="ts">
	import type { TooltipProps } from '../types/props';
	import { attrValue } from '../utils/html';
	import IconLottie from '$lib/elements/IconLottie.svelte';

	export let tooltip: TooltipProps = {};
	export let classNames: string | null = null;
	export let parentRef: HTMLElement | null = null;
</script>

<IconLottie
	name="help-center"
	size="small"
	{tooltip}
	parentRef={parentRef ?? null}
	classNames={attrValue(['cursor-pointer', classNames ?? ''])}
	on:click
/>
